import React, { useEffect } from 'react';

interface UseClickOutsideArgs {
	ref: React.MutableRefObject<any>;
	callback: () => void;
	disabled: boolean;
	exceptionsRefs?: React.MutableRefObject<any>[];
}

const useClickOutside = ({
	ref,
	callback,
	disabled,
	exceptionsRefs = [],
}: UseClickOutsideArgs) => {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				!ref.current?.contains(event.target) &&
				!exceptionsRefs.some((r) => r.current.contains(event.target))
			) {
				callback();
			}
		};
		if (disabled) {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('touchend', handleClickOutside);
		} else {
			document.addEventListener('mousedown', handleClickOutside);
			document.addEventListener('touchend', handleClickOutside);
		}
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('touchend', handleClickOutside);
		};
	}, [ref, disabled]);
};

export default useClickOutside;
